<template>
  <TransitionGroup ref="splashMessageTransition" name="list" tag="div" :class="{'d-flex' : showSplashMessage, 'd-none' : !showSplashMessage}" class="flex-column splash-message position-fixed top-right">
    <div v-for="(splashMessage, index) in splashMessages" :key="splashMessage.id" class="__content mb-0" :class="[splashMessage.variant]">
      <div class="icon" :class="splashMessage.variant">
        <svg v-if="splashMessage.variant === 'success'" xmlns="http://www.w3.org/2000/svg" width="39.98" height="39.98" viewBox="0 0 39.98 39.98">
          <g id="Icon_ionic-ios-checkmark-circle-outline" data-name="Icon ionic-ios-checkmark-circle-outline" transform="translate(-3.375 -3.375)">
            <path id="Path_933" data-name="Path 933" d="M31.02,14.061l-1.691-1.74a.364.364,0,0,0-.269-.115h0a.349.349,0,0,0-.269.115L17.066,24.133,12.8,19.866a.372.372,0,0,0-.538,0L10.55,21.577a.383.383,0,0,0,0,.548l5.382,5.382a1.7,1.7,0,0,0,1.124.548,1.783,1.783,0,0,0,1.115-.529h.01L31.03,14.609A.411.411,0,0,0,31.02,14.061Z" transform="translate(2.59 3.24)" fill="#fff"/>
            <path id="Path_934" data-name="Path 934" d="M23.365,6.066a17.292,17.292,0,1,1-12.234,5.065A17.185,17.185,0,0,1,23.365,6.066m0-2.691a19.99,19.99,0,1,0,19.99,19.99,19.987,19.987,0,0,0-19.99-19.99Z" fill="#fff"/>
          </g>
        </svg>
        <svg v-if="splashMessage.variant === 'primary'" xmlns="http://www.w3.org/2000/svg" width="39.615" height="39.615" viewBox="0 0 39.615 39.615">
          <g id="Icon_ionic-ios-information-circle-outline" data-name="Icon ionic-ios-information-circle-outline" transform="translate(-3.375 -3.375)">
            <path id="Path_935" data-name="Path 935" d="M16.552,12.6a1.963,1.963,0,1,1,1.952,1.9A1.907,1.907,0,0,1,16.552,12.6Zm.133,3.4h3.638V29.726H16.685Z" transform="translate(4.669 2.599)" fill="#fff"/>
            <path id="Path_936" data-name="Path 936" d="M23.183,6.041A17.134,17.134,0,1,1,11.06,11.06,17.028,17.028,0,0,1,23.183,6.041m0-2.666A19.808,19.808,0,1,0,42.99,23.183,19.8,19.8,0,0,0,23.183,3.375Z" fill="#fff"/>
          </g>
        </svg>
        <svg v-if="splashMessage.variant === 'warning'" xmlns="http://www.w3.org/2000/svg" width="42.983" height="42.983" viewBox="0 0 42.983 42.983">
          <path id="Icon_metro-warning" data-name="Icon metro-warning" d="M24.062,5.822l18.012,35.9H6.05l18.012-35.9Zm0-3.894A3.107,3.107,0,0,0,21.506,3.8L3.16,40.367c-1.406,2.5-.21,4.543,2.657,4.543h36.49c2.867,0,4.063-2.045,2.657-4.543h0L26.618,3.8a3.107,3.107,0,0,0-2.556-1.874Zm2.686,34.924a2.686,2.686,0,1,1-2.686-2.686A2.686,2.686,0,0,1,26.749,36.852Zm-2.686-5.373a2.686,2.686,0,0,1-2.686-2.686V20.733a2.686,2.686,0,1,1,5.373,0v8.059A2.686,2.686,0,0,1,24.062,31.479Z" transform="translate(-2.571 -1.928)" fill="#fff"/>
        </svg>
        <svg v-if="splashMessage.variant === 'danger'" id="Icon_ionic-ios-information-circle-outline" data-name="Icon ionic-ios-information-circle-outline" xmlns="http://www.w3.org/2000/svg" width="39.615" height="39.615" viewBox="0 0 39.615 39.615">
          <path id="Path_935" data-name="Path 935" d="M16.552,27.831a1.963,1.963,0,1,0,1.952-1.9A1.907,1.907,0,0,0,16.552,27.831Zm.133-3.4h3.638V10.709H16.685Z" transform="translate(1.294 -0.043)" fill="#fff"/>
          <path id="Path_936" data-name="Path 936" d="M23.183,40.324A17.134,17.134,0,1,0,11.06,35.305a17.028,17.028,0,0,0,12.123,5.019m0,2.666A19.808,19.808,0,1,1,42.99,23.183,19.8,19.8,0,0,1,23.183,42.99Z" transform="translate(-3.375 -3.375)" fill="#fff"/>
        </svg>
      </div>
      <div class="__message-content">
        <div class="__header">
          <p class="__title">{{ splashMessage.title }}</p>
          <svg xmlns="http://www.w3.org/2000/svg" width="9.285" height="9.282" viewBox="0 0 9.285 9.282" class="__close-icon" @click="closeToast(index)">
            <path id="Icon_ionic-ios-close" data-name="Icon ionic-ios-close" d="M17.028,15.93l3.316-3.316a.777.777,0,1,0-1.1-1.1l-3.316,3.316-3.316-3.316a.777.777,0,1,0-1.1,1.1L14.83,15.93l-3.316,3.316a.777.777,0,1,0,1.1,1.1l3.316-3.316,3.316,3.316a.777.777,0,1,0,1.1-1.1Z" transform="translate(-11.285 -11.289)" fill="#6e707e"/>
          </svg>
        </div>
        <p class="description">{{ splashMessage.description }}</p>
      </div>
    </div>
  </TransitionGroup>
</template>

<script>
export default {
  data () {
    return {
      splashMessages: [],
      showSplashMessage: false
    }
  },
  methods: {
    show (props) {
      this.showSplashMessage = true

      this.splashMessages.unshift({
        id: Math.random(),
        title: props.title || 'Title Here',
        description: props.description || 'Description Here',
        variant: props.variant || 'primary',
      })
      
      setTimeout(() => {
        this.splashMessages.pop()
        if (this.splashMessages.length == 0) {
          setTimeout(() => {
            this.showSplashMessage = false
          }, 300)
        }
      }, props.time || 5000)
      
      
    },
    closeToast (index) {
      this.splashMessages.splice(index, 1)
    }
  }
}
</script>

<style lang="scss" scoped>
.splash-message {
  flex-direction: column;
  gap: .75rem;
  width: 420px;
  position: fixed;
  z-index: 9999;
  // positioning
  &.top-right {
    top: 12px;
    right: 12px
  }
  &.bottom-right {
    bottom: 12px;
    right: 12px;
  }

  .__content {
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    background-color: var(--primary);
    min-width: 420px;
    // status
    &.success {
      border: 1px solid var(--success);
      background-color: var(--success);
      .__title {
        color: var(--success);
      }
      .__icon {
        color: var(--white);
      }
    }
    &.primary {
      border: 1px solid var(--primary);
      background-color: var(--primary);
      .__title {
        color: var(--primary);
      }
      .__icon {
        color: var(--white);
      }
    }
    &.warning {
      border: 1px solid var(--warning);
      background-color: var(--warning);
      .__title {
        color: var(--warning);
      }
      .__icon {
        color: var(--white);
      }
    }
    &.danger {
      border: 1px solid var(--danger);
      background-color: var(--danger);
      .__title {
        color: var(--danger);
      }
      .__icon {
        color: var(--white);
      }
    }

    .__message-content {
      position: relative;
      width: 100%;
      background-color: var(--white);
      border-radius: 0 4px 4px 0;
      height: max-content;
      padding: .5rem .5rem .5rem 1rem;
      .__header {
        display: flex;
        // title
        .__title {
          width: 90%;
          font-size: 16px;
          margin-right: auto;
          margin-bottom: 0 !important;
        }
        .__close-icon {
          right: 10px;
          top: 0;
          opacity: .5;
          margin-left: 1rem;
          cursor: pointer;
          margin-left: auto;
          &:hover {
            opacity: .8;
          }
        }
      }
      // description
      .description {
        font-size: 13px;
        margin-bottom: 0 !important;
        color: var(--gray-500);
        padding-right: .5rem;
      }
    }

    // icon styles
    .icon {
      width: 80px;
      border-top-left-radius: inherit;
      border-bottom-left-radius: inherit;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: .5rem .75rem;
    }
  }

	.list-item {
    display: inline-block;
    margin-right: 10px;
  }
  .list-enter-active, .list-leave-active {
    transition: all 1s;
  }
  .list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */ {
    opacity: 0;
    transform: translateX(30px);
  }
  
}
</style>
